var ConditionListsAgreement = require("./condition-list-agreement");

var ConditionListsPopUp = function () {
    var $currentContext = $();

    var classMap = {
        popupHeader: ".js-condition-lists-popup__header",
        productTitle: ".js-condition-lists-popup__product-title",
        productImage: ".js-condition-lists-popup__product-image"
    };

    var $modal, $popupHeader, $productTitle, $productImage, $agreementContext;
    var agreement, product;

    function setTitle() {
        var $title = $("<h3 class=\"pcg-pop-up-info__title\"></h3>");
        $title.text(product.name);
        $popupHeader.append($title);
    }

    function setImageUrl() {
        if (product.logoUrl) {
            var $logo = $("<img class=\"pcg-pop-up-info__logo\" src=\"#\" alt=\"\">")
            $logo.attr("src", product.logoUrl);
            $popupHeader.append($logo);
        }
    }

    this.show = function(currentProduct, conditions, onConfirm, onReject) {
        product = currentProduct;

        $popupHeader.empty();
        setTitle();
        setImageUrl();

        if(agreement) {
            agreement.dispose();
        }

        agreement = new ConditionListsAgreement()
            .setConditions(conditions)
            .setOnConfirm(onConfirm)
            .setOnReject(onReject);

        agreement.init($agreementContext);
        agreement.render();

        $modal.modal("show");
    }

    this.hide = function() {
        $modal.modal("hide");
    }

    function parseContext() {
        $modal = $currentContext;
        $productTitle = $(classMap.productTitle, $modal);
        $productImage = $(classMap.productImage, $modal);
        $popupHeader = $(classMap.popupHeader, $modal);
        $agreementContext = $(ConditionListsAgreement.SELECTOR, $modal);
    }

    this.init = function (context) {
        $currentContext = context || $currentContext;

        parseContext();
    };
};

Object.defineProperty(ConditionListsPopUp, "SELECTOR", {
    enumerable: false,
    configurable: false,
    writable: false,
    value: ".js-condition-lists-popup"
});

module.exports = ConditionListsPopUp;
